import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin } from 'lucide-react';
import { BRANCHES } from '../data/catalog';
import '../styles/Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <img
              src="/brand/bb-lockup-paper.svg"
              alt="Bulge Bracket"
              className="footer-wordmark-img"
              loading="lazy"
            />
            <p className="footer-tagline">
              Coached from inside the industry.
            </p>
          </div>

          <nav className="footer-nav" aria-label="Tracks">
            <p className="footer-nav-label">Tracks</p>
            {BRANCHES.map(branch => (
              <Link key={branch.id} to={`/${branch.id}`}>
                {branch.name}
              </Link>
            ))}
          </nav>

          <nav className="footer-nav" aria-label="Company">
            <p className="footer-nav-label">Company</p>
            <Link to="/#tutors">Tutors</Link>
            <Link to="/resources">Resource pack</Link>
            <Link to="/#contact">Contact</Link>
            <Link to="/terms">Terms &amp; refunds</Link>
          </nav>

          <div className="footer-connect">
            <p className="footer-nav-label">Reach us</p>
            <a href="mailto:hello@bulgebracket.co" className="footer-social">
              hello@bulgebracket.co
            </a>
            <a
              href="https://linkedin.com/company/bulgebracket"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Bulge Bracket on LinkedIn"
              className="footer-social"
            >
              <Linkedin size={16} aria-hidden="true" />
              LinkedIn
            </a>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Bulge Bracket. All rights reserved.</p>
          <p className="footer-notice">Payments secured by Stripe.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
